import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import { Jumbotron } from "./migration";
import { projects } from "../../editable-stuff/config";
import { Link } from "react-router-dom";

const Projects = () => {
  if (!projects || !projects.show) {
    return (
      <Jumbotron fluid id="projects" className="bg-light m-0">
        <Container>
          <h2 className="display-4 pb-5 text-center">Projects</h2>
          <p className="text-center">No projects to display.</p>
        </Container>
      </Jumbotron>
    );
  }

  return (
    <Jumbotron fluid id="projects" className="bg-light m-0">
      <Container>
        <h2 className="display-4 pb-5 text-center">{projects.heading}</h2>
        <Row>
          {projects.data && projects.data.length ? (
            projects.data.map((p, idx) => (
              <Col md={6} key={`proj-${idx}`}>
                <Link to={`/blog/${idx}`} style={{ textDecoration: "none", color: "inherit" }}>
                  <Card
                    className="card shadow-sm p-3 mb-5 bg-white rounded"
                    style={{ height: 220, overflow: "hidden" }}
                  >
                    <Card.Body className="d-flex flex-column">
                      <Card.Title
                        as="h5"
                        style={{
                          fontSize: "1.1rem",
                          marginBottom: 8,
                        }}
                      >
                        {p.projectName}
                      </Card.Title>
                      <Card.Text
                        style={{
                          flex: 1,
                          overflow: "hidden",
                        }}
                      >
                        {p.desc}
                      </Card.Text>
                      <div
                        style={{
                          marginTop: 8,
                          textAlign: "right",
                        }}
                      >
                        <small className="text-muted">Read more →</small>
                      </div>
                    </Card.Body>
                  </Card>
                </Link>
              </Col>
            ))
          ) : (
            <Col>
              <p>No projects to display.</p>
            </Col>
          )}
        </Row>
      </Container>
    </Jumbotron>
  );
};

export default Projects;
